import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { ResponseDatas } from '../../core/api/types';
import { ChargingHistoryResponse } from '../charging-history';
import { SessionExport } from '../sessions';

import {
  CompanyChargingAddUser,
  CompanyChargingAddUsersResponse,
  CompanyChargingFilters,
  CompanyChargingSettings,
  GetSessionsParams
} from './types';

@Injectable({
  providedIn: 'root'
})
export class CompanyChargingService {
  private readonly apiService = inject(ApiService);

  addUsers(featureClientID: number, payload: CompanyChargingAddUser[]): Observable<CompanyChargingAddUsersResponse> {
    return this.apiService
      .post<ResponseDatas<CompanyChargingAddUsersResponse>>(`company-charging/${featureClientID}/users/add`, payload)
      .pipe(map((result) => result?.datas));
  }

  deleteUser(featureClientID: number, customerID: number): Observable<void> {
    return this.apiService.delete(`company-charging/${featureClientID}/users/remove/${customerID}`);
  }

  getSessions(
    featureClientID: number,
    limit: number,
    offset: number,
    startTimestamp: number,
    endTimestamp: number,
    params: GetSessionsParams
  ): Observable<ChargingHistoryResponse> {
    return this.apiService.post<ChargingHistoryResponse>(
      `company-charging/${featureClientID}/sessions/${limit}/${offset}/${startTimestamp}/${endTimestamp}`,
      params
    );
  }

  getSessionsExport(
    featureClientID: number,
    startTimestamp: number,
    endTimestamp: number,
    params: GetSessionsParams
  ): Observable<SessionExport> {
    return this.apiService.post<SessionExport>(
      `sessions/company-charging/${featureClientID}/export/${startTimestamp}/${endTimestamp}`,
      params
    );
  }

  getSessionsFilters(featureClientID: number): Observable<CompanyChargingFilters> {
    return this.apiService.get(`company-charging/${featureClientID}/sessions/filters`);
  }

  updateSettings(payload: CompanyChargingSettings): Observable<CompanyChargingSettings> {
    return this.apiService
      .put<ResponseDatas<CompanyChargingSettings>>('company-charging', payload)
      .pipe(map((result) => result?.datas));
  }

  updateUsers(featureClientID: number, payload: CompanyChargingAddUser[]): Observable<CompanyChargingAddUsersResponse> {
    return this.apiService
      .patch<ResponseDatas<CompanyChargingAddUsersResponse>>(`company-charging/${featureClientID}/users`, payload)
      .pipe(map((result) => result?.datas));
  }
}
